module.exports = __webpack_public_path__ + "octicons.woff2?de59a97248b44599e6747a27a943f738";


/*****************
 ** WEBPACK FOOTER
 ** ./~/octicons/build/font/octicons.woff2?ef21c39f0ca9b1b5116e5eb7ac5eabe6
 ** module id = 124
 ** module chunks = 0
 **/